module.exports = __webpack_public_path__ + "static/media/creditrisk.ab3e9f98.svg";